<template>
  <div v-if="this.userInfo != null" style="height: 100%">
    <router-view :user-info="this.userInfo"></router-view>
  </div>
</template>
<script>
import { getUserData } from "@/api/auth.js";
import { mapActions } from "vuex";
export default {
  name: "ClipperEditorBase",
  data() {
    return {
      loadingInstance: undefined,
      userInfo: null
    };
  },
  methods: {
    ...mapActions("socials", ["initAccounts"]),
    ...mapActions({
      initializeUserData: "initializeUserData",
      setChannel: "setChannel"
    }),
    showLoading(message) {
      this.loadingInstance = this.$loading({
        lock: true,
        text: message,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 1)"
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    // @arg message - message to show
    showCriticalError(message) {
      this.errorInstance = this.$loading({
        lock: true,
        text: message,
        spinner: "el-icon-warning-outline",
        background: "rgba(0, 0, 0, 1)"
      });
    }
  },
  async mounted() {
    this.showLoading("Loading");
    try {
      const data = await getUserData();
      if (
        data.features.mango_clipper === "0" &&
        this.$route.name === "Mango Studio Video Editor"
      ) {
        throw Error(
          "There are no access rights to the clipper, please contact technical support."
        );
      } else {
        this.userInfo = data;
      }
      if (this.userInfo != null) {
        /** if token valid and we got list of channels */
        this.initializeUserData({
          userData: this.userInfo,
          channelId: Number(this.$route.query.streamId)
        });
        this.hideLoading();
        this.initAccounts();
      } else {
        throw Error("Authorize error");
      }
    } catch (e) {
      this.hideLoading();
      this.showCriticalError(
        `Clipper Error : ${e.message}, please try again later`
      );
    }
  }
};
</script>
<style>
#app {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
}
@font-face {
  font-family: 'Poppins';
  font-weight: lighter;
  src: url('../assets/Poppins Font/PoppinsLight-l4Zw.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: lighter;
  src: url('../assets/Poppins Font/PoppinsBlack-VxOe.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: lighter;
  src: url('../assets/Poppins Font/PoppinsBlackItalic-JXmK.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: bold;
  src: url('../assets/Poppins Font/PoppinsBoldItalic-jgZy.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: lighter;
  src: url('../assets/Poppins Font/PoppinsExtralight-6Je1.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: bold;
  src: url('../assets/Poppins Font/PoppinsExtrabold-zDdL.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: bold;
  src: url('../assets/Poppins Font/PoppinsSemibold-8l8n.otf') format('opentype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 500;
  src: url('../assets/Poppins Font/PoppinsMedium-1JPv.otf') format('opentype');
}
</style>
